export enum ErrorCodes {
  ERROR_404 = '404',
  ERROR_401 = '401'
}
